/* eslint-disable */
import { Column, ColumnProps } from 'primereact/column'
import { DataTable, DataTableProps } from 'primereact/datatable'
import { FlattenSimpleInterpolation, StyledComponent } from 'styled-components'

import React from 'react'
import { WrapperTable } from './cr-grid.style'

export interface ICrGrid {
  expanderProps?: any // TODO: To be implement
  selectionProps?: any // TODO: To be implement
  columns: ColumnProps[]
  data?: any[]
  customStyles?: StyledComponent<any, any> | FlattenSimpleInterpolation | undefined
  paginator?: boolean
  first?: number
  rows?: number
  totalRecords?: number
  onPageChange?: (event: any) => void
  paginatorTemplate?: string
  currentPageReportTemplate?: string
  // ... các prop khác nếu cần
}

export const CrGrid: React.FC<ICrGrid> = ({ columns, data, expanderProps, selectionProps, customStyles, onPageChange, paginator, first, rows, totalRecords, paginatorTemplate, currentPageReportTemplate, ...props }) => {
  // const [selected, setSelected] = useState(null)
  // const [expandedRows, setExpandedRows] = useState()
  // const rowExpansionTemplate = (_data: any) => <div>Row expand</div>
  /* selectionProps = {
    selection: selected,
    onSelectionChange: (e: any) => setSelected(e.value),
    dataKey: 'id'
  }
  expanderProps = {
    expandedRows: expandedRows,
    onRowToggle: (e: any) => setExpandedRows(e.data),
    rowExpansionTemplate: rowExpansionTemplate
  } */
  return (
    <WrapperTable customStyles={customStyles}>
      <DataTable
        value={data}
        resizableColumns
        columnResizeMode="fit"
        scrollable
        lazy
        scrollHeight="calc(100vh - 250px)"
        {...selectionProps}
        {...expanderProps}
        paginator={paginator}
        first={first}
        rows={rows}
        totalRecords={totalRecords}
        paginatorTemplate={paginatorTemplate}
        currentPageReportTemplate={currentPageReportTemplate}
        onPage={(e) => onPageChange?.(e)}
        {...props}
        ref={(r: any) => _handleSticky(r?.container)}
      >
        {expanderProps && <Column expander style={{ width: '4rem' }} className="sticky-col" />}
        {selectionProps && <Column selectionMode="multiple" style={{ maxWidth: '50px' }}/>}
        {columns.map((col: any, i: number) => {
          return <Column key={`${col.field}-${i}`} {...col} ref={(r: any) => console.log(r)} />
        })}
      </DataTable>
    </WrapperTable>
  )
}

const _handleSticky = (container: HTMLDivElement) => {
  if (!container) {
    return
  }
  container.querySelectorAll('.sticky-col').forEach((c: any) => {
    c.style.left = c.style.left || `${c.offsetLeft}px`
  })
}

/**
 * TODO :
 * props :
 *    - selectionProps: multiple / single
 *    - expanderProps : rowExpansionTemplate,
 */
